import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { loadStripe } from '@stripe/stripe-js'
import { CartProvider } from 'use-shopping-cart'

const stripePromise = loadStripe('pk_test_51HgzfjLdyXRco3IC4yEzhSMpuajoPkO19A92dd0rHf67MoBwtO7S9H2wMTAnYkiCPC9ygrGUevVWFnotvGxmT4Ex00Lk8k9Gwz')

ReactDOM.render(
  <CartProvider mode="checkout-session" stripe={stripePromise} currency="USD">
    <App />
  </CartProvider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
